import { css, html, LitElement } from 'lit';
import { Text } from '../Text/Text';
import { Button } from '../Buttons/Buttons';
import { Image } from '../Image/Image';
import './ReactionsInfoCard/ReactionsInfoCard.js';
import '../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';

class ReactionsContainer extends LitElement {
  static properties = {
    bgColor: { type: String },
    border: { type: String },
    borderRadius: { type: String },
    color: { type: String },
    height: { type: String },
    width: { type: String },
    reactions: { type: Array },
    fontSize: { type: String },
    reactionsUser: { type: Array },
    showConfirmationPopup: { type: Boolean },
    handleConfirmDelete: { type: Function },
    handleClosePopup: { type: Function },
    userMetaData: { type: Object },
    selectedEmojiToRemove: { type: Object },
    selectedEmojiId: { type: String },
    messageId: { type: String },
  };

  constructor() {
    super();
    this.showConfirmationPopup = false;
    this.addEventListener('remove-click', this.handleRemoveReactionClick);
    this.selectedEmojiToRemove = null;
    this.selectedEmojiId = null; // Initialize the selected emoji ID
  }

  handleRemoveReactionClick(e) {
    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = e.detail;
  }
  static styles = css`
    .reactions-container {
      display: flex;
      flex-direction: column;
      padding: 10px;
      box-shadow:
        2px 2px 2px var(--bg-senary-color),
        -2px -2px 2px var(--bg-senary-color);
    }
        .reactions-list-container {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .reactions-tab-container {
      display: flex;
      gap: 8px;
      padding: 0;
    }
    .emoji-tab {
      cursor: pointer;
      padding: 4px 8px;
      background: transparent;
      border-bottom: 1px solid var(--text-primary-color);
    }
    .emoji-tab:hover {
      background: var(--bg-tertiary-color);
    }
    .emoji-tab.selected {
      background: var(--bg-tertiary-color);
    }
  `;

  handleEmojiClick(emojiId) {
    this.selectedEmojiId = emojiId;
    const event = new CustomEvent('emojiTabClick', {
      detail: emojiId,
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);

    this.requestUpdate();
  }

  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.reactionType,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }
  render() {
    const updatedData = this.reactions?.map(item => ({
      ...item,
      messageId: item.messageId[0],
    }));

    return html`
      <div
        class="reactions-container"
        style="background-color: ${this.bgColor}; color: ${this.color}; 
       font-size: ${this.fontSize}; border: ${this.border}; border-radius: ${this.borderRadius}; height: ${this.height}; width: ${this.width};
      "
      >
        <div class="reactions-tab-container">
          ${updatedData?.map(
            data => html` <div class="emoji-tab ${this.selectedEmojiId === data.emojiId ? 'selected' : ''}" @click=${() => this.handleEmojiClick(data.emojiId)}>${data.src}</div> `,
          )}
        </div>
        <div class="reactions-list-container">
          ${this.selectedEmojiId && this.reactionsUser?.length > 0
            ? this.reactionsUser.map(
                user => html`
                  <reactions-info-card
                    .userName=${user.userName}
                    .userProfileImage=${user.userProfileImageUrl}
                    .imageRadius=${'50%'}
                    .imageHeight=${'40px'}
                    .imageWidth=${'40px'}
                    .isSelfReaction=${user.userId === this.userMetaData?.userId}
                    .fontSize=${this.fontSize}
                    .reactionType=${this.selectedEmojiId}
                  ></reactions-info-card>
                `,
              )
            : html`<div style="font-size: 14px ; padding: 10px" >Tap on any tab to see list</div>`}
        </div>
        ${this.showConfirmationPopup
          ? html`
              <delete-popup
                .bgColor=${'var(--bg-primary-color)'}
                .height=${'200px'}
                .width=${'400px'}
                primaryButtonBgColor=${' var(--text-danger-color)'}
                primaryButtonTextColor=${'var(--text-incoming-message)'}
                primaryButtonText="Delete"
                secondaryButtonText="Cancel"
                secondaryButtonBgColor=${' var(--bg-outgoing-message)'}
                secondaryButtonTextColor=${'var(--text-primary-color)'}
                title="Delete Reaction"
                message="Are you sure you want to remove as a reaction?"
                .handleConfirmRemove=${() => this.handleConfirmRemove()}
                .closeConfirmationPopup=${() => this.closeConfirmationPopup()}
              ></delete-popup>
            `
          : ''}
      </div>
    `;
  }
}

customElements.define('reactions-container', ReactionsContainer);
